export const STEP_AVAILABILITY = "availability"
export const STEP_PRICELIST = "pricelist"
export const STEP_PAYMENTS = "payments"
export const STEP_DESCRIPTION = "description"
export const STEP_LOCATION = "location"
export const STEP_PHOTOS = "photos"
export const STEP_PRICED_FIELDS = "priced_fields"
export const STEP_CUSTOMER_FIELDS = "customer_fields"
export const STEP_ADDITIONAL = "additional"
export const STEP_BOOKING_SETTINGS = "booking_settings"
export const STEP_ACCOMMODATION_SETTINGS = "accommodation_settings"
export const STEP_INTEGRATIONS = "integrations"
export const STEPS = {
  STEP_AVAILABILITY,
  STEP_PRICELIST,
  STEP_DESCRIPTION,
  STEP_LOCATION,
  STEP_BOOKING_SETTINGS,
  STEP_PAYMENTS,
  STEP_PHOTOS,
  STEP_PRICED_FIELDS,
  STEP_CUSTOMER_FIELDS,
  STEP_ADDITIONAL,
  STEP_ACCOMMODATION_SETTINGS,
  STEP_INTEGRATIONS
};

export const ACCOMMODATION_UNIT_RANGES = {
  MAX_BEDS_COUNT: 30,
  MAX_ROOMS_COUNT: 20,
  MAX_DEFAULT_TOTAL_STOCK_LIMIT: 100,
};



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/constants.js